import React, {useState, useRef, useEffect} from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logoutUser } from '../store/slices/authSlice';
import Logo from '../components/LogoHeader'
import HamburgerIcon from '../components/icons/HamburgerIcon'
import SearchIcon from '../components/icons/SearchIcon'
import CloseIcon from '../components/icons/CloseIcon'
import EmailIcon from '../components/icons/EmailIcon'
import ThemeToggle from '../components/ThemeToggle'


const Header = () => {

    const [open, setOpen] = useState(false)
    const navRef = useRef(null);
    const buttonRef = useRef(null);

    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.auth.isLoading);
    const isSaving = useSelector((state) => state.savingIndicator.count > 0);

    const handleLogout = () => {
        dispatch(logoutUser());
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (open && !navRef.current?.contains(e.target) && !buttonRef.current?.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [open]);

    return (
        <>
            <header className="w-full px-5 h-[60px] flex fixed justify-between items-center border-b border-custom-charcoal bg-custom-dark z-[1000]">
            <div className='inline-block'>
                <Logo />
            </div>
            <div className="flex gap-3 sm:gap-5 items-center">
                <span className={`text-xs text-white/40 transition-opacity duration-300 ${isSaving ? 'opacity-100' : 'opacity-0'}`}>
                    Saving...
                </span>

                {/* <div className=''>
                    <SearchIcon />
                </div> */}

                {/* <Link to="mailto:info@oreca.pro?subject=Enquiry from Oreca Pro Website" className='inline-block'>
                    <EmailIcon />
                </Link> */}

                <button ref={buttonRef} className='cursor-pointer' type="button" onClick={() => setOpen(!open)}>
                    {open ? (
                        <CloseIcon />
                    ) : (
                        <HamburgerIcon />
                    )}
                </button>
            </div>
            </header>
            <nav 
                ref={navRef}
                className={
                    `fixed top-[60px] w-full h-[100vh] bg-custom-darker sm:max-w-[300px] z-[1000] text-lg sm:text-sm
                    ${open ? 'right-0' : 'right-[-100%]'}
                    transition-all ease-in-out duration-500 border-l border-custom-charcoal`
                }
            >
                <ul>
                    <li>
                        <Link to="/account/overview" className='block w-full px-5 py-4 border-b border-custom-charcoal'>Account</Link>
                    </li>
                    <li>
                        <Link to="/options" className='block w-full px-5 py-4 border-b border-custom-charcoal'>Settings</Link>
                    </li>
                    <li>
                        <Link to="/info" className='block w-full px-5 py-4 border-b border-custom-charcoal'>Info</Link>
                    </li>
                    <li>
                        <Link to="/support" className='block w-full px-5 py-4 border-b border-custom-charcoal'>Support</Link>
                    </li>
                    <li>
                        <ThemeToggle />
                    </li>
                    <li>
                        <button onClick={handleLogout} className='block w-full px-5 py-4 border-b border-custom-charcoal text-left'>
                            {isLoading ? 'Logging out...' : 'Logout'}
                        </button>
                    </li>
                </ul>
            </nav>
        </>
    );
};

export default Header;
